document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a[href^="tel"]').forEach((element) => {
    element.classList.add('link-phone');
    element.addEventListener('click', function () {
      if (typeof gtag == 'function') {
        gtag('event', 'adw_click_phone');
      }
      if (typeof fbq == 'function') {
        fbq('track', 'Contact', { content_name: 'telefono' });
      }
      console.log('Click en enlace de teléfono');
    });
  });
  document.querySelectorAll('a[href^="mailto"]').forEach((element) => {
    element.classList.add('link-email');
    element.setAttribute('target', '_blank');
    element.addEventListener('click', function () {
      if (typeof gtag == 'function') {
        gtag('event', 'adw_click_email');
      }
      if (typeof fbq == 'function') {
        fbq('track', 'Contact', { content_name: 'email' });
      }
      console.log('Click en enlace de email');
    });
  });
  document.querySelectorAll('a[href*="wa.me"]').forEach((element) => {
    element.classList.add('link-whatsapp');
    element.setAttribute('target', '_blank');
    element.addEventListener('click', function () {
      if (typeof gtag == 'function') {
        gtag('event', 'adw_click_whatsapp');
      }
      if (typeof fbq == 'function') {
        fbq('track', 'Contact', { content_name: 'whatsapp' });
      }
      console.log('Click en enlace de WhatsApp');
    });
  });
  document.querySelectorAll('a[href*="api.whatsapp"]').forEach((element) => {
    element.classList.add('link-whatsapp');
    element.setAttribute('target', '_blank');
    element.addEventListener('click', function () {
      if (typeof gtag == 'function') {
        gtag('event', 'adw_click_whatsapp');
      }
      if (typeof fbq == 'function') {
        fbq('track', 'Contact', { content_name: 'whatsapp' });
      }
      console.log('Click en enlace de WhatsApp');
    });
  });
  document.querySelectorAll('a[href*="maps.google"]').forEach((element) => {
    element.classList.add('link-map');
    element.setAttribute('target', '_blank');
    element.addEventListener('click', function () {
      if (typeof gtag == 'function') {
        gtag('event', 'adw_click_map');
      }
      if (typeof fbq == 'function') {
        fbq('track', 'Contact', { content_name: 'maps' });
      }
      console.log('Click en enlace de mapa');
    });
  });

});
